var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{ref:_vm.labelRef,attrs:{"for":_vm.labelFor}},[_c('vue-six-four',{attrs:{"id":_vm.inputId,"hidden":""},on:{"vue-six-four":_vm.getFile}}),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary"},on:{"click":_vm.actionUploadImage}},[_vm._v("\n\t\t\t"+_vm._s(_vm.buttonTitle)+"\n\t\t")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e152234","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/upload-image.vue
// module id = 626
// module chunks = 1 2 3 4 9 10 22 23